var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\xF0\x9F\xA6\x86 icon \"copy\""
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.4 17H6.6C6.26863 17 6 16.7314 6 16.4V6.6C6 6.26863 6.26863 6 6.6 6H16.4C16.7314 6 17 6.26863 17 6.6V16.4C17 16.7314 16.7314 17 16.4 17Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M12 6V1.6C12 1.26863 11.7314 1 11.4 1H1.6C1.26863 1 1 1.26863 1 1.6V11.4C1 11.7314 1.26863 12 1.6 12H6",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIcon);
export default __webpack_public_path__ + "static/media/copy_icon.551be288fa7bf6f6a598bf63c74b8656.svg";
export { ForwardRef as ReactComponent };